export default __webpack_public_path__ + "static/media/W51Kitchen2.7713b752.jpg";